import { GET } from "Common/api";
import config from "lib/config";

/**
 * Cached whitelisted admin settings from `GET v1/adminsettings/public/{portalSiteId}`.
 * Mirrors {@link SettingStore} usage: call `init()` once (awaited), then `getSettingValue(name)`.
 */
class PublicAdminSettingStore {
  /** @type {Array} */
  settings = [];

  /** @type {Promise<void>|null} */
  _loadPromise = null;

  /**
   * Loads public admin settings for the current portal site. Concurrent calls share one request.
   * No request is made when `config.siteId` is missing.
   */
  async init() {
    const siteId = config.siteId;
    const hasSiteId =
      siteId !== undefined && siteId !== null && `${siteId}`.length > 0;

    if (!hasSiteId) {
      return;
    }

    if (this._loadPromise) {
      return this._loadPromise;
    }

    this._loadPromise = (async () => {
      const payload = await GET(`v1/adminsettings/public/${siteId}`).catch(
        () => null,
      );
      const list = Array.isArray(payload?.settings) ? payload.settings : [];
      this.settings = list;
    })();

    return this._loadPromise;
  }

  /**
   * Setting value from the public API cache, or `undefined` if not loaded or not present.
   * Name matching is case-insensitive (aligned with server whitelist comparisons).
   */
  getSettingValue(name) {
    const key = String(name).toLowerCase();
    const row = this.settings?.find(
      (s) => String(s.settingName).toLowerCase() === key,
    );
    return row?.settingValue;
  }
}

export default new PublicAdminSettingStore();
